import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import DownloadExcel from "utils/DownloadExcel";
import { pageSizeOptions } from "utils/HelperFunction";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import { NumericFormat } from "react-number-format";
import useInitSoDataList from "hooks/saleOrder/useInitSoDataList";
import SoDocStatus from "layouts/SoDocStatus";
import { isShowBranch } from "utils/HelperMemberFunction";
export function SaleOrderList() {
    var _useInitSoDataList = useInitSoDataList({
        initStatus: null
    }), pageModel = _useInitSoDataList.pageModel, setPageModel = _useInitSoDataList.setPageModel, filterText = _useInitSoDataList.filterText, setFilterText = _useInitSoDataList.setFilterText, data = _useInitSoDataList.data, setData = _useInitSoDataList.setData, btnempstatus = _useInitSoDataList.btnempstatus, setBtnempstatus = _useInitSoDataList.setBtnempstatus, getData = _useInitSoDataList.getData, isMemoLoading = _useInitSoDataList.isMemoLoading, soStatusCount = _useInitSoDataList.soStatusCount;
    var columnsd = [
        {
            field: "doc_number",
            headerName: "เลขที่ใบสั่งขาย",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("a", {
                    className: "tc-9",
                    href: "/sale/sale-order/edit/".concat(row.id),
                    target: "_blank",
                    children: row.doc_number
                });
            }
        },
        {
            field: "qo_doc_number_ref",
            headerName: "เลขที่อ้างอิง",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return row.qo_doc_number_ref ? /*#__PURE__*/ _jsx("a", {
                    className: "tc-9",
                    href: "/sale/quotation/edit/".concat(row.fact_new_qo_id),
                    target: "_blank",
                    children: row.qo_doc_number_ref
                }) : "-";
            }
        },
        {
            field: "full_member_name",
            headerName: "ชื่อลูกค้า",
            width: 250,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var isShowBranchMember = isShowBranch({
                    custType: row.member_customer_type,
                    isHQ: row.member_is_hq,
                    branchNo: row.member_branch_no
                });
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.full_member_name,
                        isShowBranchMember && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("br", {}),
                                "(",
                                row.member_is_hq ? "สำนักงานใหญ่" : row.member_branch_no,
                                ")"
                            ]
                        })
                    ]
                });
            }
        },
        {
            field: "customerGroupName",
            headerName: "กลุ่มลูกค้า",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: "-"
                });
            }
        },
        {
            field: "doc_issue_date",
            headerName: "วันที่ออกเอกสาร",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.doc_issue_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "dim_mst_payment_type_id",
            headerName: "เงื่อนไขชำระเงิน",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimMstPaymentType.name
                });
            }
        },
        {
            field: "sum_item_quantity",
            headerName: "จำนวนสินค้า",
            width: 110,
            sortable: false
        },
        {
            field: "grand_total_price",
            headerName: "มูลค่าสุทธิ",
            width: 110,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 2,
                        fixedDecimalScale: true,
                        value: row.grand_total_price
                    })
                });
            }
        },
        {
            field: "dim_mst_so_status_id",
            headerName: "สถานะ",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var statusID = row.dim_mst_so_status_id;
                var statusName = row.dimMstSoStatus.name;
                return /*#__PURE__*/ _jsx(SoDocStatus, {
                    statusID: statusID,
                    statusName: statusName
                }, "so-status-".concat(row.id));
            }
        }
    ];
    var getColumns = function(statusID) {
        var baseColumns = _to_consumable_array(columnsd); // คอลัมน์ทั่วไป
        var EXTRA_STATUS = [
            3,
            4
        ];
        var extraColumns = [
            {
                field: "actions",
                headerName: "จัดการ",
                width: 150,
                sortable: false,
                renderCell: function(param) {
                    var row = param.row;
                    return /*#__PURE__*/ _jsx(Button, {
                        href: "/sale/delivery-order/create/".concat(row.id),
                        target: "_blank",
                        type: "button",
                        className: "text-white bg-[#565DFF] px-3 py-2",
                        children: "สร้างใบส่งของ"
                    });
                }
            }
        ];
        if (EXTRA_STATUS.includes(statusID)) {
            return _to_consumable_array(baseColumns).concat(_to_consumable_array(extraColumns));
        }
        return baseColumns;
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "so-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2 mb-4",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ขาย"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-2 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "ใบสั่งขาย",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4 fw-bold tc-2",
                        style: {
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "ใบสั่งขาย"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == null ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(null);
                                },
                                children: [
                                    "ทั้งหมด",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 1 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(1);
                                },
                                children: "แบบร่าง"
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 2 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(2);
                                },
                                children: [
                                    "รออนุมัติ(",
                                    soStatusCount["2"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 3 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(3);
                                },
                                children: [
                                    "รอจัดส่ง(",
                                    soStatusCount["3"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 4 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(4);
                                },
                                children: [
                                    "จัดส่งบางส่วน(",
                                    soStatusCount["4"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == "overdue" ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus("5");
                                },
                                children: [
                                    "เสร็จสิ้น(",
                                    soStatusCount["5"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 6 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(6);
                                },
                                children: "ยกเลิก"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 pagezoom",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-4",
                                    style: {
                                        marginBottom: "12px"
                                    },
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: data,
                                        filename: "รายชื่อพนักงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 me-auto",
                                    style: {
                                        width: "220px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3  select-st-1  sm pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "กลุ่มลูกค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                //   onChange={(e) => {
                                                //     setCustomer(e);
                                                //   }}
                                                className: "w-100 select-st-1",
                                                options: [],
                                                placeholder: "",
                                                value: "",
                                                isDisabled: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาเลขที่,ชื่อลูกค้า",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/sale/sale-order/create",
                                    className: "btn btn btn-st-7 mb-2 px-4",
                                    children: "สร้างใบสั่งขาย"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                height: "782px",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ _jsx(DataGrid, {
                                loading: isMemoLoading,
                                getRowId: function(row) {
                                    return row.id;
                                },
                                getRowHeight: function() {
                                    return "auto";
                                },
                                rows: data,
                                pagination: true,
                                paginationMode: "server",
                                paginationModel: {
                                    page: pageModel.page - 1,
                                    pageSize: pageModel.pageSize
                                },
                                onPaginationModelChange: function(newPagination) {
                                    setPageModel(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            page: newPagination.page + 1,
                                            pageSize: newPagination.pageSize
                                        });
                                    });
                                    getData({
                                        page: newPagination.page + 1,
                                        limit: newPagination.pageSize,
                                        searchText: filterText || "",
                                        mstNewStatusID: btnempstatus
                                    });
                                },
                                rowsPerPage: pageModel.page,
                                rowCount: pageModel.total,
                                columns: getColumns(btnempstatus),
                                pageSizeOptions: pageSizeOptions,
                                checkboxSelection: true,
                                disableRowSelectionOnClick: true,
                                slotProps: {
                                    pagination: {
                                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                                    }
                                },
                                sx: {
                                    fontFamily: "Sarabun",
                                    fontSize: "18px",
                                    ".MuiDataGrid-columnHeaderTitle": {
                                        fontFamily: "Sarabun",
                                        fontSize: "18px"
                                    }
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "py-4"
            })
        ]
    });
}
